import { render, staticRenderFns } from "./PayPalSuccess.vue?vue&type=template&id=0b1167b7"
import script from "./PayPalSuccess.vue?vue&type=script&lang=js"
export * from "./PayPalSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports